import { render, staticRenderFns } from "./PassportValid.vue?vue&type=template&id=7cc87836&scoped=true&"
import script from "./PassportValid.vue?vue&type=script&lang=js&"
export * from "./PassportValid.vue?vue&type=script&lang=js&"
import style0 from "./PassportValid.vue?vue&type=style&index=0&id=7cc87836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc87836",
  null
  
)

export default component.exports